import React from "react";
import { X } from "lucide-react";
import DNSRecordsPanel from "./DNSRecordsPanel";
import { CloudFlareDnsRecord } from "../../services/tenant.service";

interface DNSManagerModalProps {
  isOpen: boolean;
  title: string;
  tenantKey: string;
  records: CloudFlareDnsRecord[];
  loading?: boolean;
  onClose: () => void;
  onRefresh: () => void;
}

const DNSManagerModal: React.FC<DNSManagerModalProps> = ({
  isOpen,
  title,
  tenantKey,
  records,
  loading = false,
  onClose,
  onRefresh,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl w-full max-w-4xl flex flex-col"
        style={{ maxHeight: "88vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 shrink-0">
          <div>
            <h2 className="text-base font-bold text-slate-900">{title}</h2>
            {tenantKey && tenantKey !== "global" && (
              <p className="text-xs text-slate-500 mt-0.5 font-mono">{tenantKey}</p>
            )}
          </div>
          <button
            onClick={onClose}
            className="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-md transition-all"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <DNSRecordsPanel
            tenantKey={tenantKey}
            records={records}
            loading={loading}
            onRefresh={onRefresh}
          />
        </div>
      </div>
    </div>
  );
};

export default DNSManagerModal;
